import type { LinkTypes } from '@@/shared-components/types/Link'

// A picked CMS link. Internal links carry the resolved entity in `object._link`
// (slug + identifier), external links use `url`. Resolved to an href via
// useBlockLinkHref() — the same `redirect()` parser CKEditor/interactions use.
// Shape compatible with AppLookup's option generic (`value` + optional `selected`).
export type BlockLinkObject = {
  value: number | string
  selected?: boolean
  name?: string
  _link?: { identifier: number; slug: string; name: string }
  id?: number | string
}

export type BlockLink = {
  type: LinkTypes | null
  object: BlockLinkObject | null
  url: string | null
  newWindow: boolean
}

export const DEFAULT_BLOCK_LINK = (): BlockLink => ({
  type: null,
  object: null,
  url: null,
  newWindow: false,
})
